import { createContext } from "react";

export const UnsupportedBillingTypeContext = createContext<{
  unsupportedBillingType: boolean;
  setUnsupportedBillingType: (val: boolean) => void;
}>({
  unsupportedBillingType: false,
  setUnsupportedBillingType: () => {},
});
